// src/hooks/redux.ts (Updated for T-10)
/**
 * Typed Redux hooks for use throughout the application
 * UPDATED: Added T-10 custom ticks support
 */

import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from '../store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Convenience selectors for common state access
export const useViewport = () => useAppSelector(state => state.viewport);
export const useNumberLines = () => useAppSelector(state => state.numberLines);
export const useSecondaryLine = () => useAppSelector(state => state.secondaryLine);
export const useCustomTicks = () => useAppSelector(state => state.customTicks); // NEW: T-10
export const useJumpIndicators = () => useAppSelector(state => state.jumpIndicators);
export const useAnnotations = () => useAppSelector(state => state.annotations);
export const useExpressions = () => useAppSelector(state => state.expressions);
export const useConstants = () => useAppSelector(state => state.constants);
export const useUI = () => useAppSelector(state => state.ui);
export const useShare = () => useAppSelector(state => state.share);
export const usePreferences = () => useAppSelector(state => state.preferences);

// Specific computed selectors
export const useIsLoading = () => useAppSelector(state => state.ui.loading || state.share.isLoading);
export const useActiveTool = () => useAppSelector(state => state.ui.activeTool);
export const useSelectedObjects = () => useAppSelector(state => state.ui.selectedObjects);
export const useTheme = () => useAppSelector(state => state.preferences.theme);
export const useLocale = () => useAppSelector(state => state.preferences.locale);

// T-10: Custom ticks specific selectors
export const useCustomTicksCount = () => useAppSelector(state => state.customTicks.ticks.length);
export const useMidpointTicks = () => useAppSelector(state => 
  state.customTicks.ticks.filter(tick => tick.type === 'midpoint')
);